// src/core/types.ts

export type DitherKind = 'error-diffusion' | 'ordered' | 'halftone';
export type Runner = 'gpu' | 'cpu';

export interface RGB { r: number; g: number; b: number }

export interface Palette {
  id: string;
  label: string;
  colors: RGB[];          // sRGB 0..255
}

export interface DitherParams {
  styleId: string;
  scale: number;          // 1..32
  tile: number;           // 1..16, algorithm-dependent semantics
  paletteId: string;
  invert: boolean;
  contrast: number;       // -100..100
  midtones: number;       // 0.1..3.0 (gamma)
  highlights: number;     // -100..100
  blur: number;           // 0..20 px
  threshold: number;      // 0..255
  thresholdEnabled: boolean;
  downscale: { enabled: boolean; w: number; h: number };
}

export const DEFAULT_PARAMS: DitherParams = {
  styleId: 'none',
  scale: 5,
  tile: 1,
  paletteId: 'bw',
  invert: false,
  contrast: 0,
  midtones: 1.0,
  highlights: 0,
  blur: 0,
  threshold: 128,
  thresholdEnabled: false,
  downscale: { enabled: false, w: 1280, h: 720 },
};

export interface PixelBuffer {
  data: Uint8ClampedArray;   // RGBA tightly packed
  width: number;
  height: number;
}

export interface DitherAlgorithm {
  id: string;
  label: string;
  kind: DitherKind;
  runner: Runner;
  /**
   * Effective Tile Size range for this algorithm. UI clamps slider to this.
   * Use `null` to hide the Tile control entirely.
   */
  tileRange: { min: number; max: number } | null;
}
